module.exports = __webpack_public_path__ + "assets/87b59b16ba5fe86fa2ec8048a19bb758.mp3";